<template>
  <footer class="site-footer">
    <div class="bh-container site-footer__grid">
      <div class="site-footer__brand">
        <h2 class="site-footer__title">Black Hills Mountain Lion Foundation</h2>
        <p class="site-footer__desc">
          Preserving the balance of nature through education, conservation, and
          responsible hunting.
        </p>
        <p class="site-footer__badge">501(c)(3) Nonprofit Organization</p>
      </div>

      <div>
        <h3 class="site-footer__heading">Quick links</h3>
        <ul class="site-footer__links">
          <li v-for="link in quickLinks" :key="link.to">
            <router-link :to="link.to">{{ link.title }}</router-link>
          </li>
        </ul>
      </div>

      <div>
        <h3 class="site-footer__heading">Connect</h3>
        <a
          class="site-footer__social"
          href="https://www.facebook.com/people/Black-Hills-Mountain-Lion-Foundation/61556313550621/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <v-icon size="22">mdi-facebook</v-icon>
          Facebook
        </a>
        <a class="site-footer__email" :href="'mailto:' + email">
          {{ email }}
        </a>
        <div class="site-footer__donate">
          <DonateButton variant="flat" color="primary" text="Donate" />
        </div>
      </div>
    </div>

    <div class="site-footer__bottom">
      <div class="bh-container">
        <p>
          © {{ year }} Black Hills Mountain Lion Foundation. All rights
          reserved.
        </p>
        <p class="site-footer__tax">
          Donations are tax-deductible to the extent allowed by law.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import DonateButton from "./DonateButton.vue";

const QUICK_LINKS = [
  { to: "/", title: "Home" },
  { to: "/sponsor", title: "Sponsor" },
  { to: "/events", title: "Events" },
  { to: "/contact", title: "Contact" },
  { to: "/donate", title: "Donate" },
];

export default {
  name: "NonProfitFooter",
  components: {
    DonateButton,
  },
  data() {
    return {
      email: "blackhillsmountainlionhunters@gmail.com",
      quickLinks: QUICK_LINKS,
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.site-footer {
  background: var(--bh-slate);
  color: #d5dbd7;
  margin-top: auto;
  text-align: left;
}

.site-footer__grid {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1.2fr;
  gap: 2.5rem;
  padding: 3.5rem 0 2.5rem;
}

.site-footer__title {
  font-family: var(--bh-font-display);
  font-size: 1.25rem;
  font-weight: 600;
  color: #fff;
  margin: 0 0 0.75rem;
  letter-spacing: -0.01em;
}

.site-footer__desc {
  margin: 0 0 1rem;
  line-height: 1.55;
  max-width: 28rem;
}

.site-footer__badge {
  display: inline-block;
  margin: 0;
  padding: 0.35rem 0.65rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  font-size: 0.8rem;
  color: #e8ece9;
}

.site-footer__heading {
  font-family: var(--bh-font-display);
  font-size: 0.95rem;
  font-weight: 600;
  color: #fff;
  margin: 0 0 1rem;
}

.site-footer__links {
  list-style: none;
  margin: 0;
  padding: 0;
}

.site-footer__links li {
  margin-bottom: 0.55rem;
}

.site-footer__links a {
  color: #c9d0cb;
  text-decoration: none;
  font-weight: 500;
}

.site-footer__links a:hover {
  color: #fff;
}

.site-footer__social,
.site-footer__email {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: #c9d0cb;
  text-decoration: none;
  margin-bottom: 0.75rem;
}

.site-footer__social:hover,
.site-footer__email:hover {
  color: #fff;
}

.site-footer__email {
  display: block;
  word-break: break-word;
  font-size: 0.92rem;
}

.site-footer__donate {
  margin-top: 1rem;
}

.site-footer__bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1.25rem 0 1.5rem;
  text-align: center;
  font-size: 0.85rem;
  color: #95a09a;
}

.site-footer__bottom p {
  margin: 0;
}

.site-footer__tax {
  margin-top: 0.35rem !important;
  font-style: italic;
}

@media (max-width: 900px) {
  .site-footer__grid {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }

  .site-footer__desc {
    margin-inline: auto;
  }

  .site-footer__social {
    justify-content: center;
  }
}
</style>
